import grey from '@material-ui/core/colors/grey';
import yellow from '@material-ui/core/colors/yellow';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';

export default {
    palette: {
        primary: {
            main: "#0074af"
        },
        secondary: {
            main: "#dd2a1b"
        },
        green: {
            backgroundColor: green[500],
            color: '#fff'
        },
        lightGreen: {
            backgroundColor: green[100],
            color: '#fff'
        },
        yellow: {
            backgroundColor: yellow[500],
            color: '#000'
        },
        lightYellow: {
            backgroundColor: yellow[100],
            color: '#fff'
        },
        red: {
            backgroundColor: red[500],
            color: '#fff'
        },
        lightRed: {
            backgroundColor: red[100],
            color: '#fff'
        },
        grey: {
            backgroundColor: grey[300],
            color: '#000'
        },
        white: {
            backgroundColor: "#fff",
            color: '#000'
        },
        black: {
            backgroundColor: grey[900],
            color: '#fff'
        },
        blueGrey: {
            backgroundColor: grey[500],
            color: '#fff'
        }
    },
};



// WEBPACK FOOTER //
// ./src/constants/theme.js